<template>
  <div class="search-page">
    <div class="container">
      <!-- Search Header -->
      <div class="search-header-wrapper">
        <div class="search-header">
          <h1>Search Results</h1>
          <p class="search-query" v-if="query">
            Showing results for: <strong>"{{ query }}"</strong>
          </p>
          <p class="results-count">{{ products.total || 0 }} products found</p>
        </div>
      </div>

      <!-- Products Grid -->
      <div class="products-wrapper">
        <div v-if="products.data && products.data.length > 0" class="products-grid">
          <product-card
            v-for="product in products.data"
            :key="product.id"
            :product="formatProduct(product)"
          />
        </div>

        <!-- Empty State -->
        <div v-else class="empty-state">
          <i class="fas fa-search"></i>
          <h2>No Products Found</h2>
          <p v-if="query">We couldn't find any products matching "{{ query }}"</p>
          <p v-else>Try searching for something else</p>
          <a href="/" class="btn-browse">Continue Shopping</a>
        </div>

        <!-- Pagination -->
        <div v-if="products.data && products.data.length > 0 && products.last_page > 1" class="pagination">
          <a
            v-if="products.prev_page_url"
            :href="products.prev_page_url"
            class="page-btn"
          >
            <i class="fas fa-chevron-left"></i> Previous
          </a>

          <span class="page-info">
            Page {{ products.current_page }} of {{ products.last_page }}
          </span>

          <a
            v-if="products.next_page_url"
            :href="products.next_page_url"
            class="page-btn"
          >
            Next <i class="fas fa-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import ProductCard from '../../components/home/ProductCard.vue'

const props = defineProps({
  products: {
    type: Object,
    required: true
  },
  query: {
    type: String,
    default: ''
  }
})

const fixImageUrl = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg'
  if (imagePath.includes('/storage/http')) {
    return imagePath.replace(/.*\/storage\/(https?:)/, '$1')
  }
  return imagePath
}

const formatProduct = (product) => {
  const sellingPrice = product.base_price
  const hasDiscount = product.compare_price && product.compare_price > product.base_price
  const discount = hasDiscount
    ? Math.round(((product.compare_price - product.base_price) / product.compare_price) * 100)
    : null

  return {
    id: product.id,
    name: product.name,
    slug: product.slug,
    price: sellingPrice,
    original_price: hasDiscount ? product.compare_price : null,
    image: fixImageUrl(product.image),
    discount: discount,
    rating: product.average_rating || 0,
    reviews: product.reviews_count || 0,
    stock_status: product.is_active ? 'in-stock' : 'out'
  }
}
</script>
